// assets/newsletter-ajax.js
(function(){
  function isNewsletterForm(form){
    if (!form) return false;
    // Heuristics that cover almost all themes/blocks
    const hasEmail = form.querySelector('input[type="email"], input[name="customer[email]"], input[name="contact[email]"], input[name="email"]');
    const hasTag = form.querySelector('input[name="contact[tags]"]');
    const isCustomerForm = /form_type=customer/i.test(new URLSearchParams(new FormData(form)).toString());
    const classHint = /\b(newsletter|email-signup|signup)\b/i.test(form.className || '');
    return !!(hasEmail || isCustomerForm || classHint || hasTag);
  }

  function ensureNewsletterFields(fd){
    // Normalize to what Shopify expects
    const email = fd.get('customer[email]') || fd.get('contact[email]') || fd.get('email') || '';
    if (email) {
      if (!fd.get('contact[email]')) fd.set('contact[email]', email);
      if (!fd.get('form_type')) fd.set('form_type', 'customer');
      if (!fd.get('contact[tags]')) fd.set('contact[tags]', 'newsletter');
    }
    return email;
  }

  function getMsgEl(form){
    let el = form.querySelector('[data-ajax-newsletter-message]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-ajax-newsletter-message', '');
      el.style.marginTop = '8px';
      el.style.minHeight = '1.2em';
      el.style.fontSize = '0.9rem';
      form.appendChild(el);
    }
    return el;
  }

  function show(el, msg, ok){
    el.textContent = msg;
    el.style.color = ok ? 'var(--color-success, #1a7f37)' : 'var(--color-error, #d72c0d)';
  }

  async function handleSubmit(e){
    const form = e.target;
    if (!isNewsletterForm(form)) return;

    e.preventDefault();

    const fd = new FormData(form);
    const email = ensureNewsletterFields(fd);
    const msgEl = getMsgEl(form);
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    const action = form.getAttribute('action') || '/contact';

    if (!email){
      show(msgEl, 'Please enter a valid email address.', false);
      return;
    }

    show(msgEl, 'Submitting…', true);
    if (submitBtn) submitBtn.disabled = true;

    try {
      // Shopify returns HTML (often a 302 -> HTML), so we Accept HTML
      const resp = await fetch(action, { method: 'POST', body: fd, headers: { 'Accept':'text/html' }});
      const html = await resp.text();

      // Best-effort parse of a success/error signal
      const ok = /Thanks|Thank you|You(?:’|'|)re subscribed|subscription/i.test(html) || resp.ok;
      const err = /(invalid|already|error|required|problem)/i.test(html);

      if (ok && !err){
        show(msgEl, 'Thanks! You’re subscribed.', true);
        form.querySelectorAll('input[type="email"], input[name="customer[email]"], input[name="contact[email]"]').forEach(i => i.value = '');
      } else {
        show(msgEl, 'There was a problem with your subscription.', false);
      }
    } catch (_){
      show(msgEl, 'Network error. Please try again.', false);
    } finally {
      if (submitBtn) submitBtn.disabled = false;
    }
  }

  // Attach once, at capture, so we beat theme handlers
  document.addEventListener('submit', handleSubmit, true);
})();
